module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm1"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_Abbreviations#fm-1"
    }
  }, [_c('em', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#fm-2"
    }
  }, [_vm._v("Preface to the Second Edition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-1"
    }
  }, [_vm._v("Quotations or Allusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-2"
    }
  }, [_vm._v("The Distribution of Biblical Quotations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-3"
    }
  }, [_vm._v("Inner-Biblical Exegesis or Extrabiblical Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-4"
    }
  }, [_vm._v("Identifying, Analyzing, and Defining Exegetical Features in Early Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-5"
    }
  }, [_vm._v("The Fulfillment Theme in the New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-6"
    }
  }, [_vm._v("The Christocentric Nature and Pneumatic Quality of New Testament Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-7"
    }
  }, [_vm._v("Is There a "), _c('em', [_vm._v("Sensus Plenior")]), _vm._v(" in the New Testament’s Use of the Old?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-8"
    }
  }, [_vm._v("Can We Reproduce the Exegesis of the New Testament?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-secf"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#sec-9"
    }
  }, [_vm._v("The Relation of the Testaments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('span', {
    attrs: {
      "href": "#/007_Introduction#fm-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/008_Chapter01#ch-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Jewish Hermeneutics in the First Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literalist Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Midrashic Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pesher Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allegorical Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/008_Chapter01#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Jesus and the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Realistic Appraisal of the Documents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phenomena of the Quotations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literalist and Midrashic Treatments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pesher Interpretations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Paradigm for Continued Study")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Early Christian Preaching and the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sermonic and Catechetical Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phenomena of the Quotations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Testimonia Verses and Blocks of Biblical Material")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exegetical Presuppositions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exegetical Practices and Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Paul and the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Letters of Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phenomena of the Quotations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literalist and Midrashic Treatments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Allegorical Interpretations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pesher Interpretations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/012_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Evangelists and the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phenomena of the Quotations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quotations in Mark and Luke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quotations in Matthew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quotations in John")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Hebrews and the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Provenance of the Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phenomena of the Quotations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exegetical Presuppositions and Practices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Biblical Argument")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Jewish Christian Tractates and the Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nature of the Materials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Phenomena of the Quotations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Literalist Treatments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pesher Interpretations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The Nature of New Testament Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christocentric Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Common, Diverse, and Developed Exegetical Patterns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Descriptive and the Normative in Exegesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/016_SelectedBibliography#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Selected Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecb6352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0